// Boutiques — what the page tells at a glance, from GET /api/shops (Backend
// app/api/shops.py::list_shops + shop_connections.serialize): connections by
// platform and state, orders imported, catalogue products, verified rights,
// and what needs a person (« À vérifier »). Pure; tested in
// ShopConnections.test.js.

export const shopState = (shop) => {
    if (shop.platform === 'shopify' && !shop.installed) return 'install';
    if (!shop.enabled) return 'paused';
    return 'active';
};

const newest = (values) => values.filter(Boolean).sort().pop() || null;

export const shopsSummary = (data) => {
    const shops = data?.connections || [];
    const byPlatform = {};
    shops.forEach((shop) => { byPlatform[shop.platform] = (byPlatform[shop.platform] || 0) + 1; });
    const tested = shops.filter((shop) => shop.last_test);
    const orderShops = shops.filter((shop) => shop.uses?.orders);
    const productShops = shops.filter((shop) => shop.uses?.products);
    return {
        total: shops.length,
        byPlatform,
        active: shops.filter((shop) => shopState(shop) === 'active').length,
        paused: shops.filter((shop) => shopState(shop) === 'paused').length,
        toInstall: shops.filter((shop) => shopState(shop) === 'install').length,
        ordersImported: orderShops.reduce((sum, shop) => sum + Number(shop.orders_sync?.total_imported || 0), 0),
        orderShops: orderShops.length,
        lastImport: newest(orderShops.map((shop) => shop.orders_sync?.last_ok_at)),
        products: productShops.reduce((sum, shop) => sum + Number(shop.impact?.products || 0), 0),
        productShops: productShops.length,
        tested: tested.length,
        rightsOk: tested.filter((shop) => shop.last_test.ok).length,
    };
};

// One line per shop problem, blocking first: { key, kind, tone, shop }.
export const shopsAttention = (data) => {
    const shops = data?.connections || [];
    const items = [];
    shops.forEach((shop) => {
        const state = shopState(shop);
        if (state === 'install') {
            items.push({ key: `install-${shop.id}`, kind: 'install', tone: 'warning', shop });
            return;
        }
        if (shop.platform === 'shopify' && shop.needs_authorization) {
            items.push({ key: `rights-new-${shop.id}`, kind: 'authorize', tone: 'warning', shop });
        }
        if (shop.last_test && !shop.last_test.ok) {
            items.push({ key: `rights-${shop.id}`, kind: 'rights', tone: 'danger', shop });
        }
        if (state === 'active' && shop.uses?.orders && shop.orders_sync?.last_error) {
            items.push({ key: `import-${shop.id}`, kind: 'import', tone: 'danger', shop });
        }
    });
    if (data && !data.parcel_monitoring && shops.some((shop) => shop.uses?.orders)) {
        items.push({ key: 'monitoring', kind: 'monitoring', tone: 'warning' });
    }
    return items.sort((a, b) => (a.tone === b.tone ? 0 : a.tone === 'danger' ? -1 : 1));
};
